import { compose } from 'recompose';
import { connect } from 'react-redux';

import SurveyTakerPage from 'components/SurveyTakerPage';
import withBodyStyling from 'styling/hocs/withBodyStyling';

import {
  answerQuestion,
  clearInvalidFormNameToScroll,
  initTakerApp,
  verifyCaptcha,
  updateConditionalShowLogicQuestionState,
} from 'taker/actions/appActions';

import {
  getSurveyAnswers,
  getCurrentPageBlockList,
  getSurveyError,
  getInvalidFormNameToScroll,
  getCurrentPage,
  getCurrentSectionHeaderBackgroundImageUrl,
  getCurrentSectionHeaderHeight,
  getCurrentSectionHeaderLogoImageAlign,
  getCurrentSectionHeaderLogoWithTextAlign,
  getCurrentSectionHeaderLogoImageUrl,
  getCurrentSectionHeaderBackgroundColor,
  isCurrentSectionHeaderFullWidth,
  getCurrentSectionHeaderPageBoxType,
  isCurrentSectionHeaderPlaceholder,
  getCurrentSectionHeaderBackgroundImageSize,
  isSurveyFullWidth,
  getDisplayPage,
  isCaptchaVerified,
  isCaptchaPending,
  isLandingCurrentSection,
  hasSurveyQuestionsSectionOnlyOnePage,
  getCurrentSectionHeaderBackgroundCoords,
  isSurveyCompleted,
  isCurrentSectionHeaderContentEnabled,
  getCurrentSectionHeaderLogoImageLinkUrl,
  shouldRenderCaptcha,
  shouldRenderPoweredBy,
  getCurrentSectionHeaderLogoImageSizePreset,
  getCurrentSectionHeaderLogoImageSize,
  getCurrentSectionHeaderLayout,
  getCurrentSectionHeaderTextContent,
  getCurrentSectionHeaderClientUuid,
  getCurrentSectionHeaderEnabled,
  getQuestionNumberingEnabled,
  shouldShowQuestionBlock,
  isConditionalShowLogicQuestion,
  getConditionalShowLogicQuestionVisibility,
} from 'taker/reducers';
import routerParams from 'config/routerParams';
import getRouterParams from 'utils/router/getRouterParams';
import getLocationQueryParam from 'utils/getLocationQueryParam';

import stylingSelector from '../domains/styling/selectors';
const { getStylingPageBackgroundColor, getStylingBodyBackgroundColor } = stylingSelector;

const mapStateToProps = (state, ownProps) => {
  const { [routerParams.surveyUuid]: surveyUuid } = getRouterParams(ownProps);

  return {
    backgroundColor: isSurveyFullWidth(state)
      ? getStylingPageBackgroundColor(state)
      : getStylingBodyBackgroundColor(state),
    surveyUuid,
    shouldRenderCaptcha: shouldRenderCaptcha(state),
    shouldRenderPoweredBy: shouldRenderPoweredBy(state),
    blockList: getCurrentPageBlockList(state),
    answerList: getSurveyAnswers(state),
    error: getSurveyError(state),
    firstInvalidFormName: getInvalidFormNameToScroll(state),
    currentPage: getCurrentPage(state),
    currentDisplayPage: getDisplayPage(state),
    headerBackgroundImageUrl: getCurrentSectionHeaderBackgroundImageUrl(state),
    headerBackgroundImageSize: getCurrentSectionHeaderBackgroundImageSize(state),
    headerLogoImageUrl: getCurrentSectionHeaderLogoImageUrl(state),
    headerLogoImageAlign: getCurrentSectionHeaderLogoImageAlign(state),
    headerLogoWithTextAlign: getCurrentSectionHeaderLogoWithTextAlign(state),
    headerHeight: getCurrentSectionHeaderHeight(state),
    headerBackgroundColor: getCurrentSectionHeaderBackgroundColor(state),
    headerBackgroundCoords: getCurrentSectionHeaderBackgroundCoords(state),
    isHeaderFullWidth: isCurrentSectionHeaderFullWidth(state),
    isHeaderPlaceholder: isCurrentSectionHeaderPlaceholder(state),
    pageBoxType: getCurrentSectionHeaderPageBoxType(state),
    isFullWidth: isSurveyFullWidth(state),
    isCaptchaVerified: isCaptchaVerified(state),
    isCaptchaPending: isCaptchaPending(state),
    isLandingCurrentSection: isLandingCurrentSection(state),
    hasSurveyQuestionsSectionOnlyOnePage: hasSurveyQuestionsSectionOnlyOnePage(state),
    isSurveyCompleted: isSurveyCompleted(state),
    isContentEnabled: isCurrentSectionHeaderContentEnabled(state),
    headerLogoImageLinkUrl: getCurrentSectionHeaderLogoImageLinkUrl(state),
    headerLogoImageSizePreset: getCurrentSectionHeaderLogoImageSizePreset(state),
    headerLogoImageSize: getCurrentSectionHeaderLogoImageSize(state),
    headerLayout: getCurrentSectionHeaderLayout(state),
    headerTextContent: getCurrentSectionHeaderTextContent(state),
    headerClientUuid: getCurrentSectionHeaderClientUuid(state),
    isHeaderEnabled: getCurrentSectionHeaderEnabled(state),
    questionNumberingEnabled: getQuestionNumberingEnabled(state),
    shouldShowQuestionBlock: (blockUuid) => shouldShowQuestionBlock(state, blockUuid),
    isConditionalShowLogicQuestion: (blockUuid) => isConditionalShowLogicQuestion(state, blockUuid),
    getConditionalShowLogicQuestionVisibility: (blockUuid) =>
      getConditionalShowLogicQuestionVisibility(state, blockUuid),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { [routerParams.surveyUuid]: surveyUuid } = getRouterParams(ownProps);

  const caseParams = {
    responseId: getLocationQueryParam(ownProps.location, routerParams.responseId),
    caseId: getLocationQueryParam(ownProps.location, routerParams.caseId),
    ticketId: getLocationQueryParam(ownProps.location, routerParams.ticketId),
    questionItemId: getLocationQueryParam(ownProps.location, routerParams.questionItemId),
    optionUuid: getLocationQueryParam(ownProps.location, routerParams.optionUuid),
    followingResponseUuid: getLocationQueryParam(ownProps.location, routerParams.followingResponseUuid),
  };

  return {
    onErrorScrollComplete: () => dispatch(clearInvalidFormNameToScroll()),
    onAnswer: (id, answer) => dispatch(answerQuestion(id, answer)),
    initApp: () => dispatch(initTakerApp(surveyUuid, caseParams)),
    captchaVerifyCallback: (token) => dispatch(verifyCaptcha(token)),
    updateConditionalShowLogicQuestionState: (questionUuid) =>
      dispatch(updateConditionalShowLogicQuestionState(questionUuid)),
  };
};

export default compose(
  withBodyStyling,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SurveyTakerPage);
